import * as React from 'react'
import { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { openPremiumDialog } from '../../../store/common/commonSlice'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import moment from 'moment-mini'

import AvatarBlock from './avatarBlock'
import PremiumDialog from '../../informationWindow/premiumDialog'
import { Link } from '../../../i18next/helpers'

import { genders } from '../../../constants'
import { Profile } from '../../../store/commonTypes'
import paths from '../../../paths'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import { RootState } from '../../../store/rootReducer'
import { MemberState } from '../../../store/member/memberTypings'
import { isUserPro } from '../../../utils/isUserPro'
import s from './profileInfo.module.sass'

interface Props {
    user: Profile
    self?: boolean
    switchEdit?: () => void
}

const ProfileInfo: React.FunctionComponent<Props> = ({ user, self, switchEdit }: Props) => {
    const [t] = useTranslation()
    const history = useHistory()
    const dispatch = useDispatch()

    const followersLink = self ? paths.myFollowers.path : paths.profileFollowers.toPath({ nick: user.nick })
    const member = useSelector<RootState, MemberState>((state) => state.member)

    return (
        <div className={s['profileInfo']}>
            <div className={s['profileInfo__avatar']}>
                {/*<img src={user.avatar_url} alt="" />*/}
                <AvatarBlock user={user} self={self} />
            </div>
            <div className={s['profileInfo__block']}>
                <div className={s['profileInfo__nick']}>{user.nick}</div>
                <div
                    className={
                        user.is_online
                            ? s['profileInfo__activity profileInfo__activity_online']
                            : s['profileInfo__activity']
                    }
                >
                    {user.is_online
                        ? t('Online')
                        : user.last_online
                        ? `${t('Last online')} ${moment(
                              user.last_online > 0
                                  ? user.last_online * 1000
                                  : (Number(new Date()) / 1000 + user.last_online) * 1000
                          ).format(t('time format'))}`
                        : ''}
                </div>
                <ul className={s['profileInfo__common']}>
                    {self && <div data-testid={'editButton'} className={s['profileInfo__edit']} onClick={switchEdit} />}

                    {user.gender > 0 && <li>{t(genders.find((x) => x.value === user.gender).label)}</li>}
                    {user.age !== 0 && <li>{`${user.age} ${t('years')}`}</li>}
                    {user.country && (
                        <li>
                            {user.country}
                            {user.region && `, ${user.region}`}
                        </li>
                    )}
                </ul>
            </div>
            <div className={s['profileInfo__about']}>{user.about}</div>
            <div className={s['profileInfo__stat']}>
                <div className={s['profileInfo__stat_views']}>
                    {user.profile_view_count} {t('views')}
                </div>
                <div>
                    <Link className={s['profileInfo__stat_followers']} to={followersLink}>
                        {user.follower_count} {t('followers')}
                    </Link>
                </div>

                {!self && member.loggedIn && (
                    <>
                        <div
                            className={s['profileInfo__stat_block']}
                            onClick={() =>
                                isUserPro(member.user.member_type)
                                    ? history.push({
                                          pathname: createLocalizedPath(paths.myBlacklist.path),
                                          search: `?user=${user.nick}`
                                      })
                                    : dispatch(openPremiumDialog())
                            }
                        >
                            {t('Block')}
                        </div>
                        {/*<div className={s['profileInfo__stat_favorite']}>*/}
                        {/*    <FavoriteButton />*/}
                        {/*</div>*/}
                    </>
                )}
            </div>
            <PremiumDialog />
        </div>
    )
}

export default memo(ProfileInfo)
